import Footer from "../../components/footer/Footer";
import MainLogo from "../../components/mainLogo/mainLogo";
import SearchBar from "../../components/searchBar/SearchBar";
import TopBar from "../../components/topBar/topBar";

function SearchPage({ setSearchPhrase }) {
  return (
    <div className="relative min-h-screen flex flex-col overflow-hidden">

      {/* ── Decorative background ── */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        {/* Top-right glow */}
        <div
          className="absolute rounded-full bg-mainBlue/15"
          style={{
            width: "680px",
            height: "680px",
            top: "-180px",
            right: "-180px",
            filter: "blur(110px)",
          }}
        />
        {/* Bottom-left glow */}
        <div
          className="absolute rounded-full bg-mainBlue/10"
          style={{
            width: "520px",
            height: "520px",
            bottom: "-140px",
            left: "-140px",
            filter: "blur(90px)",
          }}
        />
        {/* Subtle center warmth */}
        <div
          className="absolute rounded-full bg-mainAccent/5"
          style={{
            width: "400px",
            height: "400px",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -60%)",
            filter: "blur(80px)",
          }}
        />
      </div>

      <TopBar logo={false} />

      <main className="relative flex-1 flex flex-col items-center justify-center px-4 pb-20 pt-4">
        {/* Logo + heading block — animated internally */}
        <div className="w-full">
          <MainLogo />
        </div>

        {/* Search bar */}
        <div
          className="w-full max-w-4xl"
          style={{ animation: "heroFade 0.6s cubic-bezier(0.22,1,0.36,1) 0.22s both" }}
        >
          <SearchBar setSearchPhrase={setSearchPhrase} />
        </div>
      </main>

      <Footer />

      <style>{`
        @keyframes heroFade {
          from { opacity: 0; transform: translateY(22px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

export default SearchPage;
